const SpaceView = () => {
  return (
    <svg
      width="45"
      height="25"
      viewBox="0 0 45 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.56334C0 1.14765 1.14765 0 2.56334 0H41.5343C42.95 0 44.0977 1.14765 44.0977 2.56334V22.4367C44.0977 23.8524 42.95 25 41.5343 25H2.56334C1.14765 25 0 23.8524 0 22.4367V2.56334ZM16.0268 15.7038C15.7994 15.6316 15.557 15.5522 15.2965 15.4668C12.8368 14.6608 8.76728 13.3274 0.59478 12.6077C8.58482 11.9467 12.5659 10.6286 15.0148 9.81783C15.5729 9.63305 16.0515 9.47462 16.4798 9.35632C16.8772 9.20848 17.3085 9.12752 17.7592 9.12752C17.7792 9.12752 17.7992 9.12768 17.8192 9.128C18.1161 9.12291 18.4015 9.15806 18.6932 9.24178C18.7986 9.27202 18.9007 9.30551 18.9996 9.34207C19.215 9.41937 19.4207 9.51622 19.6144 9.63041C20.2692 10.0111 20.7344 10.5489 21.0176 11.1545C21.232 11.6036 21.3517 12.1044 21.3517 12.6325C21.3517 12.6447 21.3516 12.657 21.3515 12.6692C21.3533 14.1684 20.4376 15.6544 18.6932 16.0672C18.4424 16.1265 18.1911 16.1466 17.9256 16.1338C17.8705 16.1362 17.815 16.1375 17.7592 16.1375C17.131 16.1375 16.5405 15.9802 16.0268 15.7038ZM29.5366 10.8838C31.3003 10.8838 32.73 9.48896 32.73 7.7683C32.73 6.04763 31.3003 4.65276 29.5366 4.65276C27.773 4.65276 26.3433 6.04763 26.3433 7.7683C26.3433 9.48896 27.773 10.8838 29.5366 10.8838ZM32.73 17.5005C32.73 19.2212 31.3003 20.6161 29.5366 20.6161C27.773 20.6161 26.3433 19.2212 26.3433 17.5005C26.3433 15.7799 27.773 14.385 29.5366 14.385C31.3003 14.385 32.73 15.7799 32.73 17.5005Z"
        fill="#A6A6A6"
        className="fs-switch-colour"
      />
    </svg>
  );
};

export default SpaceView;
